export default __webpack_public_path__ + "static/media/Porque-NearshorIT-PT.ce7d1d21.jpg";